import { StoreService } from './services/store.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private store: StoreService, private authService: AuthService) { }
  async ngOnInit() {
    await this.store.load();
    this.authService.me();
  }
}
